export type GutachtenVersand = 'email' | 'post' | 'beide' | '';

export interface VersandOption {
  id: Exclude<GutachtenVersand, ''>;
  emoji: string;
  label: string;
  beschreibung: string;
  empfohlen?: true;
  color: string;
  bgColor: string;
  borderColor: string;
}

export const VERSAND_OPTIONEN: VersandOption[] = [
  {
    id: 'email',
    emoji: '📧',
    label: 'Per E-Mail',
    beschreibung: 'PDF-Gutachten sofort in Ihrem Postfach',
    empfohlen: true,
    color: '#1E5FB7',
    bgColor: '#EFF6FF',
    borderColor: '#1E5FB7',
  },
  {
    id: 'post',
    emoji: '📬',
    label: 'Per Post',
    beschreibung: 'Original gedruckt, zugestellt per Brief',
    color: '#4B5563',
    bgColor: '#F9FAFB',
    borderColor: '#6B7280',
  },
  {
    id: 'beide',
    emoji: '🔄',
    label: 'Beides',
    beschreibung: 'E-Mail vorab + Original per Post',
    color: '#1E5FB7',
    bgColor: '#EFF6FF',
    borderColor: '#1E5FB7',
  },
];

export function canProceedGutachtenVersand(value: GutachtenVersand): boolean {
  return value !== '';
}

interface Props {
  value: GutachtenVersand;
  onChange: (v: GutachtenVersand) => void;
}

export function GutachtenVersandStep({ value, onChange }: Props) {
  return (
    <div className="space-y-6">
      <div className="text-center mb-2">
        <h2 className="text-[24px] font-bold text-gray-900">
          Wie möchten Sie das fertige Gutachten erhalten?
        </h2>
        <p className="text-[14px] text-gray-500 mt-1">Bitte wählen Sie eine Versandart</p>
      </div>

      <div className="space-y-3">
        {VERSAND_OPTIONEN.map(opt => {
          const selected = value === opt.id;
          return (
            <button
              key={opt.id}
              onClick={() => onChange(opt.id)}
              className="w-full text-left rounded-2xl border-2 transition-all active:scale-[0.99] relative"
              style={{
                minHeight: 88,
                borderColor: selected ? opt.borderColor : '#E5E7EB',
                background: selected ? opt.bgColor : '#FFFFFF',
                boxShadow: selected ? `0 0 0 3px ${opt.borderColor}22` : undefined,
              }}
            >
              <div className="flex items-center gap-4 px-5 py-4">
                <span className="text-[32px] leading-none flex-shrink-0">{opt.emoji}</span>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <span
                      className="text-[17px] font-bold"
                      style={{ color: selected ? opt.color : '#111827' }}
                    >
                      {opt.label}
                    </span>
                    {opt.empfohlen && (
                      <span
                        className="text-[11px] font-bold px-2 py-0.5 rounded-full"
                        style={{ background: '#1E5FB7', color: '#FFFFFF' }}
                      >
                        Empfohlen
                      </span>
                    )}
                  </div>
                  <p className="text-[13px] text-gray-500 mt-0.5 leading-snug">
                    {opt.beschreibung}
                  </p>
                </div>
                <div
                  className="w-6 h-6 rounded-full border-2 flex items-center justify-center flex-shrink-0 transition-all"
                  style={{
                    borderColor: selected ? opt.borderColor : '#D1D5DB',
                    background: selected ? opt.borderColor : 'transparent',
                  }}
                >
                  {selected && (
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                      <path d="M2 6L5 9L10 3" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  )}
                </div>
              </div>
            </button>
          );
        })}
      </div>

      {!value && (
        <p className="text-[12px] text-gray-400 text-center flex items-center justify-center gap-1">
          <span className="text-red-400">*</span> Pflichtfeld — bitte eine Option wählen
        </p>
      )}
    </div>
  );
}
